<template>
<div id="wechatFooter">
    <div class="TTL-table top30">
    <el-table :data="param.list" :key="index" stripe="true" empty-text="">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column align="left" label="图片" min-width="160">
            <template #default="scope">
                <div class="TTL-banner-image-cate" @click.stop="uploadimages(scope.$index)">
                <el-image :src="scope.row.thumb ? scope.row.thumb : require('@/assets/avatar/footer/index.png')" fit="cover" class="TTL-image-box-small" v-if="scope.row.label=='index'"/>
                <el-image :src="scope.row.thumb ? scope.row.thumb : require('@/assets/avatar/footer/cate.png')" fit="cover" class="TTL-image-box-small" v-if="scope.row.label=='cate'"/>
                <el-image :src="scope.row.thumb ? scope.row.thumb : require('@/assets/avatar/footer/add.png')" fit="cover" class="TTL-image-box-small" v-if="scope.row.label=='add'"/>
                <el-image :src="scope.row.thumb ? scope.row.thumb : require('@/assets/avatar/footer/member.png')" fit="cover" class="TTL-image-box-small" v-if="scope.row.label=='member'"/>
                </div>
            </template>
        </el-table-column>
        <el-table-column align="center" label="图片名称" min-width="250">
            <template #default="scope">
                <div class="TTL-name-info">
                <span v-if="!scope.row.isedit">{{scope.row.typename}}</span>
                <div class="TTL-input TTL-form-input" v-if="scope.row.isedit">
                <el-input v-model="scope.row.typename" placeholder="请填写图片名称" clearable />
                </div>
                <a class="TTL-name-btn" v-if="!scope.row.isedit" @click="scope.row.isedit=true"></a>
                <a class="TTL-name-btn-right" v-if="scope.row.isedit" @click="UpdateFootername(scope.row)"></a>
                </div>
            </template>
        </el-table-column>
        <el-table-column align="center" label="排序" min-width="160">
            <template #default="scope">
                <div class="TTL-name-info">
                <span v-if="!scope.row.issort">{{scope.row.sort}}</span>
                <div class="TTL-input TTL-form-input width100" v-if="scope.row.issort">
                <el-input v-model="scope.row.sort" placeholder="请填写排序序号" />
                </div>
                <a class="TTL-name-btn" v-if="!scope.row.issort" @click="scope.row.issort=true"></a>
                <a class="TTL-name-btn-right" v-if="scope.row.issort" @click="[ChangeFooterSort(scope.row),scope.row.issort=true]"></a>
                </div>
            </template>
        </el-table-column>
        <el-table-column align="center" label="是否显示" min-width="120">
            <template #default="scope">
                <div class="TTL-switch" style="text-align:center !important"><el-switch v-model="scope.row.isshow" @click="ChangeIsShow(scope.row)" /></div>
            </template>
        </el-table-column>
    </el-table>
    </div>
</div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_WECHAT from '@/Interface/Shop/wechat';
export default {
    props:['value'],
    components: {},
    data() {
        return {
           param: {
               uploadimageIndex:'', //获取当前上传图片的序号
               list:[
                   {id:'',thumb:'',name:'',jumptype:'',jumpurl:'',sort:'',isshow:false},
               ],
           },
        }   
    },

    mounted() {
        var _this=this;
        setTimeout(function() {
            _this.GetWechatFooters(); //获取banner信息列表
        },200);
    },

    methods: {


        /** 修改底部设置名称 **/
        UpdateFootername(item) {
            INTERFACE_WECHAT.CHANGE_FOOTER_TYPENAME({id:item.id,typename:item.typename,label:item.label,isshow:1}).then((res) => {
                if(res.status > 0) return false;
                item.isedit=false;
                //回调父组件操作
                this.$emit('finish');
                this.GetWechatFooters();
            });
        },


        /** 修改图片排序序号 **/
        ChangeFooterSort(item) {
            INTERFACE_WECHAT.CHANGE_FOOTER_SORT({isshow:1,id:item.id,sort:item.sort,label:item.label}).then((res) => {
                if(res.status > 0) return false;
                //回调父组件操作
                this.$emit('finish');
                this.GetWechatFooters();
            });
        },


        /** 修改图片是否显示 **/
        ChangeIsShow(item) {
            INTERFACE_WECHAT.CHANGE_FOOTER_ISSHOW({isshow:1,id:item.id,settingshow:item.isshow ? 1 : 0,label:item.label}).then((res) => {
                if(res.status > 0) {
                    item.isshow ? item.isshow=false :  item.isshow=true;
                    return false;
                }
                //回调父组件操作
                this.$emit('finish');
                this.GetWechatFooters();
            });
        },


        ///////////////////////////////////////////
        ///////////////////////////////////////////
        //基础操作

        GetWechatFooters() {
            var obj=document.getElementById("wechatFooter");
            this.$loading.openloading(obj);
            INTERFACE_WECHAT.GET_WECHAT_FOOTER().then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.isshow=res.data.show ? true : false;
                 this.param.list=res.data.list;
                 for(var i=0;i<this.param.list.length;i++) this.param.list[i].isshow=this.param.list[i].isshow==1 ? true : false;
                 console.log(res.data);
            });
        },


        /** 上传图片信息 **/
        uploadimages(index) {
            this.uploadimageIndex=index;                          //标记当前上传图片序号
            var obj=document.querySelector('#TTLFiles');          //获取文件对象
            obj.click();                                          //点击触发上传图片
            obj.addEventListener('change',this.uploadimagedata);  //添加监听事件
        },


        /** 上传图片信息操作 **/
        uploadimagedata(e) {
            var _this=this;
            this.file=e.target.files[0];       //获取上传的图片
            e.target.value=null;                //清空数据
            document.querySelector('#TTLFiles').removeEventListener('change',this.uploadimagedata);  //解除监听事件

            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:this.file}).then((res) => {
                if(res.status > 0) return false;

                //上传图片信息
                var url=_this.$ImageAddress+res.data.url;
                var listinfos=_this.param.list[_this.uploadimageIndex];
                INTERFACE_WECHAT.UPDATE_FOOTER_IMAGE({id:listinfos.id,url:url,label:listinfos.label,isshow:1}).then((res) => {
                    if(res.status > 0) return false;
                    //刷新banner信息列表
                    listinfos.thumb=url;
                    listinfos.id=res.data.id;
                    //回调父组件操作
                    this.$emit('finish');
                    _this.GetWechatFooters(); 
                });
            });
        },

        //基础操作
        ///////////////////////////////////////////
        ///////////////////////////////////////////

    },

}
</script>
<style lang="scss" Scoped>
.el-switch__label * {font-size: 13px !important;letter-spacing: 1px !important;}
.el-switch__label.is-active {color:#666666 !important;}
.TTL-banner-image-cate .el-image {width:55px;height:55px;border-radius: 6px;overflow: hidden;}
.TTL-name-info {display: inline-flex;width:100%;align-items: center;justify-content: center;}
.TTL-name-btn {margin-left:10px;width:20px;height:20px;background-size:15px;background-position: center;background-image:url(@/assets/icon/edit-blue.png);background-repeat: no-repeat;cursor: pointer;}
.TTL-name-btn-right {margin-left:10px;width:20px;height:20px;background-size:18px;background-position: center;background-image:url(@/assets/icon/right-blue.png);background-repeat: no-repeat;cursor: pointer;}
.TTL-pet-image {cursor: pointer;}
</style>